import { LocalStorageChangeEvent } from "../common/constants";
export const storageAvailable = type => {
  try {
    var storage = window[type];
    const x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
};
export const localStorageAvailable = () => storageAvailable('localStorage');
export const getItemFromLocalStorage = key => localStorageAvailable() && localStorage.getItem(key);
export const setItemToLocalStorage = (key, value) => {
  if (storageAvailable('localStorage')) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {}
  }
  const event = new CustomEvent(LocalStorageChangeEvent);
  event.key = key;
  event.value = value;
  document.dispatchEvent(event);
};
export const removeItemFromLocalStorage = key => localStorageAvailable() && localStorage.removeItem(key);